export const USER_LOGIN_LOADING ='USER_LOGIN_LOADING'
export const USER_LOGIN_SUCCESS ='USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILED ='USER_LOGIN_FAILED'
export const USER_LOGOUT='USER_LOGOUT'

export const USER_REGISTER_LOADING ='USER_REGISTER_LOADING'
export const USER_REGISTER_SUCCESS ='USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAILED ='USER_REGISTER_FAILED'
